angular.module('shared').filter('numberAbbreviate', [() => {
  return function(number) {
    return number > 999 ? `${Math.floor(+number / 1000)}k` : number;
  };
}]);